import { theme } from "../../theme/theme";
import { APPLICATION_ROUTES } from "../../shared-logic/routes";
import { InlineLink } from "../ReusableStyledComponents/InlineLink";
import { Body, H2 } from "../Typography";
import { VerticalSpacing } from "../VerticalSpacing";
import { MarketingStepsWrapper, StepPerkz, StepSVG, StepText } from "./MarketingSteps.styles";
import { Step1 } from "./Step1";
import { Step2 } from "./Step2";
import { Step3 } from "./Step3";

const features = [
    <>
        <strong>Unique and novel:</strong> There is no other platform out there doing for Content Creators what Authory does.
    </>,
    <>
        <strong>Easy to try:</strong> Signup takes customers less than 3 minutes, and with your referral link they'll get a 30 day free trial.
    </>,
    <>
        <strong>Trustworthy:</strong> 64% of our customers select the yearly plan.
    </>,
    <>
        <strong>Affordable pricing:</strong> $15 per month or $144 per year make it an easy decision.
    </>
];

const features3 = [
    <>
        <strong>Exclusive perk:</strong> Users who sign up with your custom link automatically get 30 days free trial instead of the standard 14 days.
        That way, they also benefit if you refer them to Authory.
    </>,
    <>
        <strong>Reliable payments:</strong> You'll receive monthly reports detailing the number of signups, new customers and your earnings.
    </>,
    <>
        <strong>We are a team:</strong> Authory is growing in large part thanks to word of mouth. Our Partner Program is a way to enhance this. And we
        are fully committed to the success of our Partners.
    </>
];

export const MarketingPartnerSteps = () => {
    return (
        <MarketingStepsWrapper>
            <Step1
                leftSide={
                    <>
                        <VerticalSpacing bottom={24} breakpoints={[{ screen: theme.breakpoints.tablet, marginBottom: 40 }]}>
                            <H2 as="h2">
                                <strong>Sign up</strong> to our Authory Partner Program
                            </H2>
                        </VerticalSpacing>
                        <VerticalSpacing bottom={32} breakpoints={[{ screen: theme.breakpoints.tablet, marginBottom: 40 }]}>
                            <Body>
                                Whether you are an affiliate manager, an agency, or an author, coach or other type of content creator yourself:{" "}
                                <strong>Anyone can join the Authory Partner Program.</strong>
                            </Body>
                        </VerticalSpacing>
                        <VerticalSpacing bottom={32} breakpoints={[{ screen: theme.breakpoints.tablet, marginBottom: 40 }]}>
                            <Body>
                                Simply <InlineLink href={APPLICATION_ROUTES.SIGNUP}>create an Authory account</InlineLink>, then go to the{" "}
                                <InlineLink href={APPLICATION_ROUTES.SETTINGS_REFERRAL}>Invite section</InlineLink>.
                            </Body>
                        </VerticalSpacing>
                    </>
                }
                rightSide={<StepSVG as="img" src="/authory_static_files/images/features/curate/combine_desktop.png" />}
            />
            <Step2
                leftSide={
                    <VerticalSpacing top={30}>
                        <StepPerkz>
                            {features.map((ft, index) => (
                                <Body key={index} as="li">
                                    {ft}
                                </Body>
                            ))}
                        </StepPerkz>
                    </VerticalSpacing>
                }
                rightSide={
                    <StepText>
                        <VerticalSpacing bottom={24} breakpoints={[{ screen: theme.breakpoints.tablet, marginBottom: 40 }]}>
                            <H2 as="h2">
                                Share Authory with <strong>your audience</strong>
                            </H2>
                        </VerticalSpacing>
                        <VerticalSpacing bottom={32} breakpoints={[{ screen: theme.breakpoints.tablet, marginBottom: 40 }]}>
                            <Body>
                                In your Authory account, you'll find a custom link that you can then share with your audience in any way you like.
                                Every new paying customer who has signed up with your link means you'll get paid.
                            </Body>
                        </VerticalSpacing>
                        <VerticalSpacing bottom={32} breakpoints={[{ screen: theme.breakpoints.tablet, marginBottom: 40 }]}>
                            <Body>
                                Authory offers a unique and novel service that's incredibly sticky with content creators, meaning{" "}
                                <strong>you'll share a service your audience is going to love.</strong>
                            </Body>
                        </VerticalSpacing>
                    </StepText>
                }
                useNormalOrder
            />
            <Step3
                leftSide={
                    <>
                        <VerticalSpacing bottom={24} breakpoints={[{ screen: theme.breakpoints.tablet, marginBottom: 40 }]}>
                            <H2 as="h2">
                                <strong>Earn</strong>
                            </H2>
                        </VerticalSpacing>
                        <VerticalSpacing bottom={32} breakpoints={[{ screen: theme.breakpoints.tablet, marginBottom: 40 }]}>
                            <Body>
                                We'll send you <strong>USD 30 for every new paying customer who signed up with your custom link.</strong>
                            </Body>
                        </VerticalSpacing>
                        <VerticalSpacing bottom={32} breakpoints={[{ screen: theme.breakpoints.tablet, marginBottom: 40 }]}>
                            <Body>Payouts take place on a monthly basis, and there is no minimum you need to achieve.</Body>
                        </VerticalSpacing>
                    </>
                }
                rightSide={
                    <VerticalSpacing top={0} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 80 }]}>
                        <StepPerkz>
                            {features3.map((ft, index) => (
                                <Body key={index} as="li">
                                    {ft}
                                </Body>
                            ))}
                        </StepPerkz>
                    </VerticalSpacing>
                }
            />
        </MarketingStepsWrapper>
    );
};
